export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoCliente: {
    pt: 'Novo cliente',
    en: 'New customer',
    de: 'Neuer Kunde',
    es: 'Nuevo cliente',
  },
  importXlsx: {
    pt: 'Importar Excel',
    en: 'Import Excel',
    de: 'Excel importieren',
    es: 'Importar Excel',
  },
  importarClientes: {
    pt: 'Importar Clientes',
    en: 'Import Clients',
    de: 'Kunden importieren',
    es: 'Importar Clientes',
  },
  selecionarArquivo: {
    pt: 'Selecionar arquivo',
    en: 'Select file',
    de: 'Datei auswählen',
    es: 'Seleccionar archivo',
  },
  cancelar: {
    pt: 'Cancelar',
    en: 'Cancel',
    de: 'Abbrechen',
    es: 'Cancelar',
  },
  importar: {
    pt: 'Importar',
    en: 'Import',
    de: 'Importieren',
    es: 'Importar',
  },
  arquivoXlsx: {
    pt: 'Arquivo Excel (.xlsx ou .xls)',
    en: 'Excel file (.xlsx or .xls)',
    de: 'Excel-Datei (.xlsx oder .xls)',
    es: 'Archivo Excel (.xlsx o .xls)',
  },
  importacaoSucesso: {
    pt: 'Clientes importados com sucesso',
    en: 'Clients imported successfully',
    de: 'Kunden erfolgreich importiert',
    es: 'Clientes importados con éxito',
  },
  colunasObrigatorias: {
    pt: 'O arquivo deve conter as colunas: CNPJ, Código, Sequência e Nome',
    en: 'The file must contain the columns: CNPJ, Código, Sequência and Nome',
    de: 'Die Datei muss die Spalten enthalten: CNPJ, Código, Sequência und Nome',
    es: 'El archivo debe contener las columnas: CNPJ, Código, Sequência y Nome',
  },
  erroColunasInvalidas: {
    pt: 'Colunas faltando no arquivo',
    en: 'Missing columns in file',
    de: 'Fehlende Spalten in der Datei',
    es: 'Columnas faltantes en el archivo',
  },
  validandoArquivo: {
    pt: 'Validando arquivo...',
    en: 'Validating file...',
    de: 'Datei wird validiert...',
    es: 'Validando archivo...',
  },
};
